import React, { useState } from "react";
import { BiSolidUserPlus } from "react-icons/bi";
import { FiX } from "react-icons/fi";

const Customer = ({ customer, setCustomer }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => {
    setIsOpen(false);
    setCustomer({});
  };
  const handleSubmit = () => {
    setIsOpen(false);
    console.log(customer);
  };

  return (
    <div>
      <button
        onClick={handleOpen}
        className="absolute top-0 lg:right-5 right-3   bg-[#0D868C] text-white rounded-full flex justify-center items-center lg:w-12 w-10 lg:h-12 h-10"
      >
        <BiSolidUserPlus className="lg:size-8 size-7" />
      </button>

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white shadow-xl rounded-[10px] md:w-[450px] w-[70%] mx-auto p-5 space-y-6">
            <div className="flex justify-between items-center border-b-2 border-[#DEDEDE] pb-2 mb-4">
              <h1 className="lg:text-[1.2rem] text-[1rem] font-bold text-[#0D868C]">
                Create Customer
              </h1>
              <button type="button" onClick={handleClose}>
                <FiX className=" size-6 text-[#0D868C]" />
              </button>
            </div>
            <form>
              <div className="mb-4 flex flex-col items-start">
                <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                  Customer Name
                </label>
                <input
                  type="text"
                  value={customer.customerName}
                  onChange={(e) =>
                    setCustomer((prevCustomer) => ({
                      ...prevCustomer,
                      customerName: e.target.value,
                    }))
                  }
                  placeholder="Name"
                  className="w-full outline-none  rounded-none  text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                />
              </div>
              <div className="mb-4 flex flex-col items-start">
                <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                  Customer Number
                </label>
                <input
                  type="text"
                  value={customer.customerNumber}
                  onChange={(e) =>
                    setCustomer((prevCustomer) => ({
                      ...prevCustomer,
                      customerNumber: e.target.value,
                    }))
                  }
                  placeholder="03000000000"
                  className="w-full outline-none rounded-none   text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                />
              </div>

              <div className="text-center mt-8">
                <button
                  type="submit"
                  onClick={handleSubmit}
                  className="text-white bg-[#0D868C] w-[50%] py-3 rounded-full outline-none uppercase font-normal text-[.9rem]"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Customer;
